import { render, staticRenderFns } from "./BomTypeCharacteristic.vue?vue&type=template&id=58a01135"
import script from "./BomTypeCharacteristic.vue?vue&type=script&lang=js"
export * from "./BomTypeCharacteristic.vue?vue&type=script&lang=js"
import style0 from "./BomTypeCharacteristic.vue?vue&type=style&index=0&id=58a01135&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports